export default (FlexApiRequest = window.FlexApiRequest) => {

    class AuthenticationRepository {
        authenticate(oauthAccessToken, oauthRefreshToken) {
            return FlexApiRequest.POST({ path: '/api/v1/auth/createsessionfromoauthaccesstoken' })
                .send({ oauthAccessToken, oauthRefreshToken })
                .then((response) => {
                    return response.data.session;
                });
        }

    }

    return new AuthenticationRepository();
};